import React, { useState, useEffect } from "react";

const PhotoRedactions = ({
  redactionImg,
  redacted,
  redirectUrl
}: {
  redactionImg: string;
  redacted: boolean;
  redirectUrl: string;
}) => {
  const [isImgLoading, setIsImgLoading] = useState(false);
  useEffect(() => {
    setIsImgLoading(true);
    const img = new Image();
    img.src = redactionImg;
    img.onload = () => {
      setIsImgLoading(false);
    };
    img.onerror = () => {
      setIsImgLoading(false);
    };
  }, [redactionImg]);

  return (
    <div className="permissions-allowed">
      <div className="img-content">
        {isImgLoading ? (
          <div className="loading-img-skeleton">
            <span className="loading-spinner">
              <span className="fa fa-spinner fa-spin"></span>
            </span>
          </div>
        ) : (
          <img
            className="redaction-source-img img-clickable"
            src={redactionImg}
            alt="Redaction Source"
            onClick={() => (window.location.href = redirectUrl)}
          />
        )}
      </div>
      <div className="permissions-content">
        <div className={`redaction ${redacted ? "redacted" : "un-redacted"}`}>
          {redacted ? "Redacted" : "UnRedacted"}
        </div>
        {redacted ? (
          <div className="redaction-content">
            Do not publish, share, or otherwise <br />
            use this photo
          </div>
        ) : (
          <div className="redaction-content">
            This photo can be published, <br /> shared, or otherwise used
            anywhere
          </div>
        )}
      </div>
    </div>
  );
};

export default PhotoRedactions;
